import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_edit-pencil",
  "use": "svg_edit-pencil-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"svg_edit-pencil\"><path d=\"m9.576 4.268.987-.987c.52-.52 1.365-.52 1.885 0l.943.943c.52.52.52 1.365 0 1.886l-.986.986M9.575 4.268l-6.41 6.41a1.333 1.333 0 0 0-.386.826L2.62 13.33c-.037.413.31.759.723.722l1.827-.161c.311-.027.604-.164.825-.385l6.41-6.41m-2.828-2.83 2.829 2.83\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol